<template>
	<div style="width: 100;height: 100%;text-align: center;" @touchend="touchEnd" @touchstart="touchStart">
		  <Carousel
			v-if="!errorShow"
			v-model="playIndex"
			arrow="never"
			dots="none">
			<CarouselItem v-for="(item,index) in photos" :key="index">
				<img v-if="item.type=='img'" style="height: 100%;width: 100%;" :src="item.img" />
				<video autoplay="autoplay" controls="controls" v-else="item.type='video'" style="height: 100%;width: 100%;margin-top: 12rem;" :src="item.video"></video>
			</CarouselItem>
		</Carousel>
		<div v-if="errorShow" style="width: 100%;height: 100%;padding-top: 12rem;">
			<div style="font-size: 22px;">
				<Icon size="140" color="#ed4014" type="md-close-circle" /><br>
				发生错误，请联系管理员
			</div>
		</div>
		<div v-if="promptShow" style="width: 100%;height: 100%;background: #e8eaec;opacity: 0.5;">
			<div  style="position: fixed;right: 0px;top: 10rem;font-size: 16px;">
				<p class="textClass" style="font-size: 4rem;"><<<向左滑动</p>
			</div>
		</div>
	</div>
</template>
<script>
	import {param,GetQueryString,getByteLen} from '@/utils/index.js'
	export default {
		data(){
			return {
				playIndex:0,
				errorShow:false,
				promptShow:true,
				photos:[
				],
				startX:0,
				startY:0,
				moveEndX :0,
				moveEndY:0
				
			}
		},
		created:function(){
			if(GetQueryString('type')=='1'){
				for(let i=0;i<45;i++){
					let obj={
						img:require('../../../../../assets/image/gwphoto/'+i+'.jpg'),
						type:'img'
					};
					this.photos[i]=obj;
				}
			}else if(GetQueryString('type')=='2'){
				for(let i=0;i<5;i++){
					let obj={
						img:require('../../../../../assets/image/gwphoto/jt'+i+'.jpg'),
						type:'img'
					};
					this.photos[i]=obj;
				}
			}else if(GetQueryString('type')=='3'){
				for(let i=0;i<4;i++){
					let obj={
						img:require('../../../../../assets/image/gwphoto/azb'+i+'.jpg'),
						type:'img'
					};
					this.photos[i]=obj;
				}
				this.photos[4]={
					// video:require('../../../../../assets/video/azbxc.mp4'),
					type:'video'
				};
				this.FullScreen();
			}else{
				this.$router.push('/404');
			}
			
		},
		methods:{
			touchStart(e){
				this.startX = e.changedTouches[0].pageX,
				this.startY = e.changedTouches[0].pageY;
			},
			touchEnd(e){
				this.moveEndX = e.changedTouches[0].pageX,
				this.moveEndY = e.changedTouches[0].pageY;
				let X=this.moveEndX-this.startX;
				let Y=this.moveEndY-this.startY;
				if(X > 0){
					this.playIndex-=this.playIndex>0?1:0;
				}else if(X < 0){
					this.playIndex+=this.playIndex<this.photos.length-1?1:0;
					this.promptShow=false;
				}
			},
			FullScreen(){
				let element = document.documentElement;
				if (element.requestFullscreen) {
					element.requestFullscreen();
				} else if (element.webkitRequestFullScreen) {
					element.webkitRequestFullScreen();
				} else if (element.mozRequestFullScreen) {
					element.mozRequestFullScreen();
				} else if (element.msRequestFullscreen) {
					element.msRequestFullscreen();
				}
			}
			
		}
	}
</script>
<style>
	.textClass{
		-webkit-animation: myfirst 5s;
	}
	
	
@-webkit-keyframes myfirst
{
	0% {color: #5cadff;}
	10% {color: #808695;}
	20% {color: #5cadff;}
	30% {color: #808695;}
	40% {color: #5cadff;}
	50% {color: #808695;}
	60% {color: #5cadff;}
	70% {color: #808695;}
	80% {color: #5cadff;}
	90% {color: #808695;}
	100% {color: #5cadff;}
}
</style>


// WEBPACK FOOTER //
// src/components/views/WeChat/Person/Photo/index.vue